





























import * as Gdpr from '@/model';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import Article from '@/components/Article.vue';
import Section from '@/components/Section.vue';

@Component({
  components: {
    Article,
    Section,
  },
})
export default class Chapter extends Vue {
  @Prop({
    default: {
      display: false,
      h1: '',
      h2: '',
      sec: [],
      art: [],
      address: { chapter: 0 },
    },
  })
  private data!: Gdpr.Chapter;
  @Prop({ default: false }) private interactive!: boolean;

  private get address(): string {
    return 'chapter-' + this.data.address.chapter;
  }

  private get first(): string {
    if (this.data != null) {
      for (const section of this.data.sec) {
        for (const article of section.art) {
          return Gdpr.HtmlEncode(article.h1);
        }
      }
      for (const article of this.data.art) {
        return Gdpr.HtmlEncode(article.h1);
      }
    }
    return '';
  }

  private get last(): string {
    let article: Gdpr.Article | null = null;
    if (this.data != null) {
      for (const section of this.data.sec) {
        for (const a of section.art) {
          article = a;
        }
      }
      for (const a of this.data.art) {
        article = a;
      }
    }
    if (article != null) {
      return Gdpr.HtmlEncode(article!.h1);
    }
    return '';
  }

  private get h1(): string {
    return Gdpr.HtmlEncode(this.data.h1);
  }

  private get h2(): string {
    return Gdpr.HtmlEncode(this.data.h2);
  }

  private get displayed(): boolean {
    return this.data.display;
  }

  private get selected(): boolean {
    return this.interactive && this.data.display;
  }

  @Emit('chapter-click')
  private fireChapterClick(): Gdpr.Chapter {
    return this.data;
  }

  @Emit('article-click')
  private fireArticleClick(article: Gdpr.Chapter): Gdpr.Chapter {
    return article;
  }
}
